module.exports = __webpack_public_path__ + "static/media/larry4.ba1b286e.mp3";